<template>
  <h3 class="pb5">Imprimer rapport cumulatif des dossiers (CDX_0147)</h3>
  <ButtonBar @fermer="fermer" @imprimer="imprimer"/>
</template>

<script>
import ButtonBar from "@/components/rapports/Rechercher/ButtonBar.vue";

export default {
  name: "DossiersCumulatifImprimer",
  components: {ButtonBar},
  mounted() {
    this.$root.$refs.breadcrumbComp.ajout("Divers");
  },
  methods: {
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
    imprimer() {
      this.$root.$refs.breadcrumbComp.activeBallBeat = true;
      var criteresRapportVO;
      criteresRapportVO.titre = "DossiersActifsParIntervenant";
      this.$store.dispatch("rapports/obtenirRapportDiversAction", {
        criteresRapportVO: criteresRapportVO
      })
          .then(() => {
            this.$root.$refs.breadcrumbComp.activeBallBeat = false;
          });
    }
  },
}
</script>
